// Google Analytics Configuration
export const initGoogleAnalytics = () => {
  // Désactiver Google Analytics en local
  const isLocal = window.location.hostname === 'localhost' || 
                  window.location.hostname === '127.0.0.1' ||
                  window.location.hostname.includes('192.168.')
  
  if (isLocal) {
    console.log('[Analytics] Désactivé en environnement local')
    return {
      trackEvent: () => {} // Fonction vide en local
    }
  }

  // Chargement asynchrone du script Google Analytics
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=G-NMMY0C6R9L`

  // Ajout du script au head
  document.head.appendChild(script)

  // Configuration de base de Google Analytics
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', 'G-NMMY0C6R9L')

  // Fonction pour envoyer des événements personnalisés
  const trackEvent = (eventName, parameters = {}) => {
    gtag('event', eventName, parameters)
  }

  return {
    trackEvent
  }
} 